import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'printcaserecfooterview',
  templateUrl: './printcaserecfooterview.component.html',
  styleUrls: ['./printcaserecfooterview.component.scss']
})

export class  PrintcaserecfooterviewComponent implements OnInit {
  
  public Date: Date;

 

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {

    this.Date = new Date();
  }
  

 
 
 


 
}
